import { render, staticRenderFns } from "./ListRedeemedPrize.vue?vue&type=template&id=38578b6d&"
import script from "./ListRedeemedPrize.vue?vue&type=script&lang=js&"
export * from "./ListRedeemedPrize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports